module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-core-js/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Learning People","short_name":"LP","start_url":"/","background_color":"#2A2D58","theme_color":"#2A2D58","display":"browser","icon":"src/static/img/favicon.jpg","include_favicon":true},
    },{
      plugin: require('../node_modules/@imgix/gatsby/gatsby-browser.js'),
      options: {"plugins":[],"domain":"learningpeople.imgix.net","secureURLToken":"qeyh52px6AXUN6px","sourceType":"webProxy","defaultImgixParams":{"auto":"format,compress"},"fields":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[],"importWorkboxFrom":"local"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
